import styled from 'styled-components';

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: #f3f4f6;
  color: #374151;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  border-radius: 10px;
  
  &:hover {
    background-color: #fee2e2;
    border-color: #fca5a5;
    color: #dc2626;
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  i {
    font-size: 18px;
  }
`;

export default Button;
